import { defineComponent as _defineComponent } from 'vue'
import { ResourceContributor } from '~/types/resource';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceContributorCard',
  props: {
    contributorType: null,
    resourceContributor: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})